import { jsx as _jsx, Fragment as _Fragment } from "@emotion/react/jsx-runtime";
import { useEffect, useRef, useState } from 'react';
import { css } from '@emotion/react';
import { getBrazeMetaFromUrlFragment } from '@root/src/web/lib/braze/forceBrazeMessage';
import { useOnce } from '@root/src/web/lib/useOnce';
import { useHasBeenSeen } from '@root/src/web/lib/useHasBeenSeen';
import { submitComponentEvent } from '@root/src/web/browser/ophan/ophan';
const wrapperMargins = css `
	margin: 18px 0;
`;
const COMPONENT_TYPE = 'RETENTION_EPIC';
export const canShowBrazeEpic = async (brazeMessagesPromise, brazeArticleContext) => {
    const forcedBrazeMeta = getBrazeMetaFromUrlFragment();
    if (forcedBrazeMeta) {
        return {
            show: true,
            meta: forcedBrazeMeta,
        };
    }
    try {
        const brazeMessages = await brazeMessagesPromise;
        const message = await brazeMessages.getMessageForEndOfArticle(brazeArticleContext);
        return {
            show: true,
            meta: {
                dataFromBraze: message.extras,
                logImpressionWithBraze: () => {
                    message.logImpression();
                },
            },
        };
    }
    catch (e) {
        return { show: false };
    }
};
const BrazeEpicWithSatisfiedDependencies = ({ BrazeComponent, meta, countryCode, idApiUrl, }) => {
    const [hasBeenSeen, setNode] = useHasBeenSeen({
        rootMargin: '-18px',
        threshold: 0,
        debounce: true,
    });
    const epicRef = useRef(null);
    useOnce(() => {
        submitComponentEvent({
            component: {
                componentType: COMPONENT_TYPE,
                id: meta.dataFromBraze?.ophanComponentId,
            },
            action: 'INSERT',
        });
    }, [meta?.dataFromBraze, epicRef.current]);
    useEffect(() => {
        if (hasBeenSeen && meta && meta.dataFromBraze) {
            meta.logImpressionWithBraze();
            // Log VIEW event with Ophan
            submitComponentEvent({
                component: {
                    componentType: COMPONENT_TYPE,
                    id: meta.dataFromBraze?.ophanComponentId,
                },
                action: 'VIEW',
            });
        }
    }, [hasBeenSeen, meta]);
    if (meta.dataFromBraze) {
        return (_jsx("div", Object.assign({ ref: setNode, css: wrapperMargins }, { children: _jsx("div", Object.assign({ ref: epicRef }, { children: _jsx(BrazeComponent, { componentName: meta.dataFromBraze.componentName, brazeMessageProps: meta.dataFromBraze, subscribeToNewsletter: async (newsletterId) => {
                        await fetch(`${idApiUrl}/users/me/newsletters`, {
                            method: 'PATCH',
                            body: JSON.stringify({
                                id: newsletterId,
                                subscribed: true,
                            }),
                            credentials: 'include',
                        });
                    }, countryCode: countryCode }, void 0) }), void 0) }), void 0));
    }
    return null;
};
export const MaybeBrazeEpic = ({ meta, countryCode, idApiUrl }) => {
    const [BrazeComponent, setBrazeComponent] = useState();
    useEffect(() => {
        import(
        /* webpackChunkName: "guardian-braze-components-end-of-article" */ '@guardian/braze-components/end-of-article')
            .then((module) => {
            setBrazeComponent(() => module.BrazeEndOfArticleComponent);
        })
            .catch((error) => window.guardian.modules.sentry.reportError(error, 'braze-epic'));
    }, []);
    return (_jsx(_Fragment, { children: BrazeComponent ? (_jsx(BrazeEpicWithSatisfiedDependencies, { BrazeComponent: BrazeComponent, meta: meta, countryCode: countryCode, idApiUrl: idApiUrl }, void 0)) : (_jsx("div", {}, void 0)) }, void 0));
};
